export const LOCAL_API_URL = "http://localhost:8080";
export const HOST_NAME = "https://cnaqabackend.com";